import { createPayment } from '../payment/factory';
import { ActionParams } from './types';

export function createActionParams(
	cardId = -1,
	paymentObject = createPayment(),
	sourceId = -1,
	targetId = -1,
	choiceInt = -1
): ActionParams {
	return {
		cardId,
		paymentObject,
		sourceId,
		targetId,
		choiceInt,
	};
}
